<template>
  <div v-if="contact.id" class="text-sm">
    <div class="mb-4">
      <div v-for="field in fields" :key="field.identifier">
        <div v-if="isUrl(contact.contact[field.identifier])" class="truncate">
          <a
            :href="contact.contact[field.identifier]"
            target="_blank"
            class="text-gray-900 hover:underline"
          >{{ contact.contact[field.identifier] }}</a>
        </div>
        <div v-else>
          {{ contact.contact[field.identifier] }}
          <span
            v-if="field.identifier == 'fax' && contact.contact[field.identifier]"
            class="ml-2 text-sm text-gray-400"
          >(fax)</span>
        </div>
      </div>
    </div>
    <div class="mb-4" v-if="contact.address">
      {{ contact.address.street }}
      <br v-if="contact.address.street" />
      {{ contact.address.postal_code }} {{ contact.address.city }}
    </div>
    <div v-if="noDetails" class="text-gray-500 mb-10">Geen contactgegevens</div>
    <div v-else class="text-sm mt-8">
      <div v-for="customfield in customfields" :key="customfield.id" class="mb-2">
        <div class="text-xs text-gray-400">{{ customfield.name }}</div>
        <div v-if="isUrl(customfield.value)" class="truncate">
          <a
            :href="customfield.value"
            target="_blank"
            class="text-gray-800 hover:underline"
          >{{ customfield.value }}</a>
        </div>
        <div v-else>{{ customfield.value || '-' }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapObjectsById } from "@/functions.js";

export default {
  props: {
    contact: Object
  },

  computed: {
    noDetails() {
      let customfieldLength = this.customfields.filter(f => f.value);

      return this.fields.length == 0 && customfieldLength == 0;
    },

    fields() {
      let getter =
        this.contact.contact_type == "organization"
          ? this.$store.getters.organizationFields
          : this.$store.getters.personFields;

      return getter
        .filter(f => f.identifier != "name")
        .filter(f => f.identifier != "fullname")
        .filter(f => this.contact.contact[f.identifier]);
    },

    customfields() {
      let map = mapObjectsById(this.contact.customfields);

      return this.$store.state.settings.customfields.map(customfield => {
        return {
          ...customfield,
          value: map[customfield.id] ? map[customfield.id].value : null
        };
      });
    }
  },

  methods: {
    isUrl(url) {
      if (!url) return false;

      let reg = new RegExp("^(http|https)://.\\S+$", "i");

      return reg.test(url);
    }
  }
};
</script>
